

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_3,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_4,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>DONACION Y ENTREGA DE UNIFROMES A LA ESCUELA DE FORMACION DEPORTIVA REAL FORTALEZA</h3>
                <p>
                    COOPMULMAG, comprometida con el desarrollo integral de la niñez y 
                    la juventud, impulsa espacios deportivos que promueven la disciplina, 
                    el trabajo en equipo y los valores cooperativos. A través del apoyo a 
                    iniciativas comunitarias como esta escuela de fútbol, fortalecemos el 
                    tejido social y sembramos esperanza en las nuevas generaciones.</p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}